import { each } from 'lodash'
import { getReadableExId } from 'modules/Programs/utils/exerciseDomain'
import newOrgSampleExercisesLandscape from '../templates/newOrgSampleExercisesLandscape.json'
import newOrgSampleExercisesPortrait from '../templates/newOrgSampleExercisesPortrait.json'

export const getSampleExIdsByOrigExIds = () => {
  const newSampleExIdByOrigExId = {}

  each(newOrgSampleExercisesLandscape, (ex, origExId) => {
    const newExId = getReadableExId(ex.name)
    newSampleExIdByOrigExId[origExId] = newExId
  })

  return newSampleExIdByOrigExId
}

export const getSampleExercises = (exVidOrientation = 'landscape', newSampleExIdByOrigExId) => {
  const sampleExercisesData =
    exVidOrientation === 'landscape' ? newOrgSampleExercisesLandscape : newOrgSampleExercisesPortrait
  const sampleExercises = {}

  each(sampleExercisesData, (ex, origExId) => {
    const newExId = newSampleExIdByOrigExId[origExId]
    const updatedEx = {
      ...ex,
      createdAt: Date.now(),
      updatedAt: Date.now(),
      id: newExId,
    }

    sampleExercises[newExId] = updatedEx
  })

  return sampleExercises
}
